export type ButtonColor = "emphasis" | "component" | "transparent" | "danger" | "subtle";
export type ButtonSize = "xs" | "sm" | "md" | "lg" | "xl";
export type ButtonVariant = "filled";

export const buttonSizeSettings: Record<ButtonSize, string> = {
    "xs": "rounded px-2 py-1 text-xs font-semibold shadow-sm",
    "sm": "rounded px-2 py-1 text-sm font-semibold shadow-sm",
    "md": "rounded-md px-2.5 py-1.5 text-sm font-semibold shadow-sm",
    "lg": "rounded-md px-4 py-2 text-sm font-semibold shadow-sm",
    "xl": "rounded-md px-3.5 py-2.5 text-sm font-semibold shadow-sm"
}

export const buttonColorSettings: Record<ButtonColor, string> = {
    "emphasis": "theme-dark bg-emphasis text-contrast-primary ring-indigo-500 hover:bg-emphasis-secondary disabled:bg-indigo-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2",
    "component": "bg-secondary text-contrast-primary ring-color-border hover:bg-tertiary disabled:bg-muted focus:ring-2 focus:ring-offset-2 border border-color-border",
    "transparent": "hover:bg-primary text-contrast-primary !ring-0 disabled:text-gray-500 !shadow-none rounded",
    "danger": "theme-dark bg-red-600 text-contrast-primary ring-red-500 hover:bg-red-700 disabled:bg-red-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2",
    "subtle": "text-contrast-primary ring-color-border hover:bg-tertiary focus:ring-2 focus:ring-offset-2 border border-color-border/50"
}